<template>
  <div class="session-description-container">
    <div :class="sessionActive ? 'class-description live ' + classColor : 'class-description ' + classColor">
      <strong>{{ currentClass.classInfo.nickname }}</strong>
      <div>{{ currentClass.classInfo.grade }}<span v-if="currentClass.classInfo.grade != 'Other'">th grade</span>, {{ currentClass.classInfo.subject }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClassItemBanner",
  props: ["sessionActive", "currentClass"],
  computed: {
    classColor() {
      return this.$filters.colorAssign(this.currentClass.classId);
    }
  }
};
</script>

<style lang="scss">

</style>